import React from "react";
import notificationIcon from "../../assets/images/notification.svg";
import closeIcon from "../../assets/images/closeIcon.svg";

const CATEGORY_COLORS = {
  CRITICAL: "#E53E3E",
  STATUS_CHANGE: "#F9A021",
  GENERAL_UPDATE: "#054997",
  SYSTEM: "#53AC82",
  SENSOR_DATA: "#054997",
};

const formatAction = (action) => {
  const cleaned = String(action || "").replace(/^SEE_/i, "");
  const words = cleaned.split(/[_\s]+/).filter(Boolean);
  return words.length
    ? `See ${words.map((word) => word[0] + word.slice(1).toLowerCase()).join(" ")}`
    : "";
};

export default function NotificationTimelineDrawer({
  open,
  timeline,
  loading,
  onClose,
  onNotificationPress,
}) {
  return (
    <div
      className={`mmt-drawer-overlay ${open ? "is-open" : ""}`}
      aria-hidden={!open}
    >
      <button
        className="mmt-drawer-backdrop"
        onClick={onClose}
        aria-label="Close notifications"
      />
      <aside className="mmt-timeline-drawer">
        <button
          className="mmt-drawer-close"
          onClick={onClose}
          aria-label="Close"
        >
          <img src={closeIcon} alt="" />
        </button>
        <h2>Notifications</h2>
        <div className="mmt-drawer-divider" />
        {loading ? (
          <div className="mmt-drawer-empty">Loading...</div>
        ) : timeline.length ? (
          <div className="mmt-timeline-list">
            {timeline.map((item) => {
              const color = CATEGORY_COLORS[item.category] || "#4d4e50";
              const parts = String(item.message || "").split(" – ");
              const quickJumpLabel = item.quickJump?.action
                ? formatAction(item.quickJump.action)
                : item.quickJump?.destination
                  ? formatAction(item.quickJump.destination)
                  : "";
              const isPressable = !!(item.openUrl || item.quickJump);
              return (
                <button
                  key={item.id || `${item.message}-${item.time}`}
                  className={`mmt-timeline-item ${isPressable ? "is-pressable" : ""}`}
                  onClick={() => isPressable && onNotificationPress(item)}
                  disabled={!isPressable}
                >
                  <span
                    className="mmt-category-bar"
                    style={{ backgroundColor: color }}
                  />
                  <span className="mmt-timeline-row">
                    <span className="mmt-timeline-icon">
                      <img src={item.iconURL || notificationIcon} alt="" />
                    </span>
                    <span className="mmt-timeline-copy">
                      <span className="mmt-category-label" style={{ color }}>
                        {String(item.category || "GENERAL").replace("_", " ")}
                      </span>
                      <strong>{parts[0] || item.title || "Senior Life"}</strong>
                      <span>{`${parts[1] || item.title || item.message || ""}${item.sourceTool ? ` (${item.sourceTool})` : ""}`}</span>
                      {quickJumpLabel ? <em>{quickJumpLabel}</em> : null}
                    </span>
                  </span>
                  <small>{item.time}</small>
                </button>
              );
            })}
          </div>
        ) : (
          <div className="mmt-drawer-empty">No notifications</div>
        )}
      </aside>
    </div>
  );
}
